import { useEffect, useRef } from 'react';

import useBrandingStore from 'storages/brandingStore';

const getBrandTitle = (currentTitle: string | undefined): string => {
  const resolvedTitle = currentTitle || 'PocketSafe';

  if (resolvedTitle.includes('|')) {
    const segments = resolvedTitle.split('|');
    return segments[segments.length - 1].trim();
  }

  return resolvedTitle;
};

const usePageTitle = (title: string) => {
  const setPageTitle = useBrandingStore(state => state.setPageTitle);
  const brandTitleRef = useRef<string | null>(null);

  useEffect(() => {
    if (!brandTitleRef.current) {
      brandTitleRef.current = getBrandTitle(useBrandingStore.getState().pageTitle);
    }

    const brandTitle = brandTitleRef.current;
    setPageTitle(`${title} | ${brandTitle}`);

    return () => {
      setPageTitle(brandTitle);
    };
  }, [setPageTitle, title]);
};

export default usePageTitle;
